module.exports = [{"type":"title","text":"2025-06-17"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"U本位永續合約：Websocket“有限深度档位”推播間隔調整為200ms或500ms。"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/changelog/2025-06-17.json
// module id = yMtp
// module chunks = 3